import {Component, Input} from '@angular/core';
import { saltosDeLinea } from "../../../../utils/utilities";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-procedimientos-especialidades',
  standalone: true,
  imports: [
    NgForOf,
    NgIf
  ],
  templateUrl: './procedimientos-especialidades.component.html',
  styleUrl: './procedimientos-especialidades.component.css'
})
export class ProcedimientosEspecialidadesComponent {

  @Input() procedimientos: string ='';

  get procedimientosEnLista(): string[] {
    // Divide el string en un arreglo utilizando un salto de línea como delimitador
    return this.procedimientos.split('\n').filter(item => item.trim() !== '');
  }


}
